import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './components/shared/ProtectedRoute';
import { ConfirmDialogProvider } from '@omit/react-confirm-dialog';
import 'react-toastify/dist/ReactToastify.css';
import ScrollToTop from './components/shared/ScrollToTop';
import AccountSetup from './pages/AccountSetup';

const Login = lazy(() => import('./pages/Login'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const Orders = lazy(() => import('./pages/Orders'));
const StoreSetting = lazy(() => import('./pages/StoreSetting'));
const Users = lazy(() => import('./pages/Users'));
const OrderDetails = lazy(() => import('./pages/OrderDetails'));
const PageNotFound = lazy(() => import('./pages/PageNotFound'));
const NotifyCustomer = lazy(() => import('./pages/NotifyCustomer'));
const ConfirmArrival = lazy(() => import('./pages/ConfirmArrival'));

function App() {
  return (
    <ConfirmDialogProvider>
      <Router>
        <Suspense>
          <Routes>
            {/* Public Route */}
            <Route path="/" element={<Login />} />

            {/* Protected Routes with Role-Based Access */}
            <Route
              path="/dashboard"
              element={<ProtectedRoute element={<Dashboard />} allowedRoles={['Admin', 'StoreManager', 'StoreStaff']} />}
            />
            <Route
              path="/orders"
              element={<ProtectedRoute element={<Orders />} allowedRoles={['Admin', 'StoreManager', 'StoreStaff']} />}
            />
            <Route
              path="/order/:orderId"
              element={<ProtectedRoute element={<OrderDetails />} allowedRoles={['Admin', 'StoreManager', 'StoreStaff']} />}
            />
            <Route
              path="/users"
              element={<ProtectedRoute element={<Users />} allowedRoles={['Admin']} />}
            />
            <Route
              path="/store-settings"
              element={<ProtectedRoute element={<StoreSetting />} allowedRoles={['Admin', 'StoreManager']} />}
            />

            {/* Public or Less Restricted Routes */}
            <Route path="/notify-customer/:orderId" element={<NotifyCustomer />} />
            <Route path="/confirm-arrival/:orderId" element={<ConfirmArrival />} />
            <Route path="/setup-account" element={<AccountSetup />} />

            {/* Fallback Route */}
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </Suspense>
      </Router>
      <ScrollToTop />
    </ConfirmDialogProvider>
  );
}

export default App;